import React from 'react';

import { Box, Text } from '@adsk/alloy-react-box';
import { useLocale } from '@adsk/alloy-react-locale';
import { OverflowTooltip } from '@adsk/alloy-react-tooltip';

import { Activity, ActivityType } from '../../types';

export function ActivityNameCell({
  activity,
  canExpand,
  onClick,
}: {
  activity: Activity;
  canExpand: boolean;
  onClick: () => void;
}) {
  const { T } = useLocale(({ locale }) => require(`../../i18n/${locale}.json`));

  const { isWbs } = activity;
  const isMilestone = activity.type === ActivityType.Milestone && !isWbs;
  return (
    <Box
      display="grid"
      gridColumn={canExpand ? 2 : '1 /-1'}
      gridTemplateColumns="9px 1fr"
      alignItems="center"
      style={{
        columnGap: '6px',
      }}
      onClick={onClick}
    >
      {isMilestone && (
        <Box
          backgroundColor="charcoal700"
          width="9px"
          height="9px"
          borderRadius="2px"
          style={{
            transform: 'rotate(45deg)',
          }}
        />
      )}
      <Box gridColumn={isWbs ? '1 /-1' : 2}>
        <OverflowTooltip content={activity.name}>
          <Text
            {...(isWbs ? { typography: 'heading5', color: 'charcoal900' } : {})}
          >
            {activity.name ?? T.translate('NO_SCHEDULE_ACTIVITY_NAME')}
          </Text>
        </OverflowTooltip>
      </Box>
    </Box>
  );
}
